import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";

const useConnectorShared = () => {
  const { components: ownedConnectors } = useSelector((store) => store.designer.cxfComponents);
  const { sharedConnectors } = useSelector((store) => store.portal.connectors);
  const { user } = useAuth0();

  const isConnectorOwnedShared = (connector_id) => {
    // ownedConnectors is an array of connectors from tenant
    const connector = ownedConnectors?.find((c) => c.id === connector_id);

    if (connector && connector.created_by_id === user?.cxfUserId) {
      return true;
    }

    if (connector && connector.user_name === user?.name) {
      return true;
    }

    const isSharedConnector = sharedConnectors?.some(
      (c) => c.connector_id === connector_id && c.shared_user_id === user?.cxfUserId
    );

    if (isSharedConnector) {
      return true;
    }

    return false;
  };

  return {
    ownedConnectors,
    isConnectorOwnedShared,
  };
};

export default useConnectorShared;
